var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaginationRightIconDoubleArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:none;stroke:#A7ABC3;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pagination-icon-arrow",
    transform: "translate(-4 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_31",
    className: "st0",
    d: "M8,3h22c2.2,0,4,1.8,4,4v22c0,2.2-1.8,4-4,4H8c-2.2,0-4-1.8-4-4V7C4,4.8,5.8,3,8,3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_321",
    transform: "translate(-2.5 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_24",
    className: "st1",
    d: "M16.5,23l5-5l-5-5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_36",
    className: "st1",
    d: "M22,23l5-5l-5-5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationRightIconDoubleArrow);
export default __webpack_public_path__ + "static/media/pagination-right-icon-double-arrow.d911bfdf4dcf8347e1a249959f4b80fc.svg";
export { ForwardRef as ReactComponent };